import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

export const DiscardDialog = ({
	open = false,
	onAccept = () => {},
	onDecline = () => {},
}) => {
	return (
		<Dialog open={open} onClose={onDecline}>
			<DialogTitle>Are you sure?</DialogTitle>
			<DialogContent>
				<DialogContentText id='label--discard--dialog'>
					Your unsaved edits will be lost.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onDecline}>Cancel</Button>
				<Button onClick={onAccept}>Proceed</Button>
			</DialogActions>
		</Dialog>
	);
};
